import ThankYouBlock from './ThankYouBlock'

export default ThankYouBlock
